import React, { useEffect, useRef, useState } from 'react';
import { Button, Modal, Form, Row, Col, Table, Dropdown } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faBolt, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { withRFSToken } from '../../../Services/axios.js';
import Select from 'react-select';
import { GETDESTINATION } from '../../../Utils/conts.js';
import { toast } from 'react-toastify';

const QuotationSettings = () => {
    const [formData, setFormData] = useState({ rate: '', divisor: '', shipment_type: '' });
    const [isSaving, setIsSaving] = useState(false);
    const [getDestination, setGetDestination] = useState([]);
    const shipmentTypeOptions = [
        { value: 'air_cargo', label: 'Air Cargo' },
        { value: 'courier', label: 'Courier' },
    ];

    const fetchDestination = async () => {
        try {
            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: `${item.port_code} - ${item.station_name}`,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchSettings = async () => {
        try {
            const res = await withRFSToken.get('general-setting/get-setting');
            const innerData = res?.data?.response_data?.settings;
            console.log("innerData", innerData)
            let shpType;
            let dvsr;
            if (innerData.shipment_type) { shpType = innerData?.shipment_type; } else { shpType = 'air_cargo'; }
            if (innerData.divisor) { dvsr = innerData?.divisor } else { dvsr = '6000' }
            setFormData({
                rate: innerData?.rate,
                divisor: dvsr,
                origin: innerData?.origin,
                shipment_type: shpType,
            });
        } catch (error) {
            console.error('Error fetching settings:', error);
            toast.error('Failed to load settings');
        }
    };

    const handleShipmentTypeChange = async (selected) => {
        const value = selected?.value || '';
        const newDivisor = value === 'air_cargo' ? '6000' : value === 'courier' ? '5000' : '';
        const updated = { ...formData, shipment_type: value, divisor: newDivisor };
        setFormData(updated);
        try {
            const payload = { settings: { rate: updated.rate, divisor: updated.divisor, origin: updated.origin, shipment_type: value } };
            const res = await withRFSToken.post('general-setting/save-setting', payload);
            const success = res?.data?.response_code == 200;
            if (success) {
                toast.success(res?.data?.response_msg || 'Shipment type updated');
            } else {
                toast.error(res?.data?.response_msg || 'Failed to update shipment type');
            }
        } catch (error) {
            console.error('Error saving shipment type:', error);
            toast.error('Failed to update shipment type');
        }
    };

    useEffect(() => {
        fetchSettings();
        fetchDestination();
    }, []);

    const handleOnSave = async () => {
        setIsSaving(true);
        const payload = { settings: { rate: formData.rate, divisor: formData.divisor, origin: formData?.origin } };
        try {
            const res = await withRFSToken.post('general-setting/save-setting', payload);
            const success = res?.data?.response_code == 200;
            if (success) {
                toast.success(res?.data?.response_msg);
            } else {
                toast.error(res?.data?.response_msg);
            }
            await fetchSettings();
        } catch (error) {
            console.error('Error saving settings:', error);
            toast.error('Failed to save settings');
        } finally {
            setIsSaving(false);
        }
    };

    const SBack = localStorage.getItem('SettingsBack');

    return (
        <>
            {/* <div className=""> */}
                {/* <Header page_type='fsm' logo_url='/ForwarderShipments/Quotation' /> */}
                {/* <Header page_type='fsm' logo_url={SBack ? SBack : '/ForwarderShipments/Quotation'} sBackUrl={SBack ? SBack : '/ForwarderShipments/Quotation'} />
                <div className="main-panel">
                    <div className="row">
                        <LeftSettings /> */}
                        <div className='col-9 col-xxl-9 stting_right'>
                            <div className='settingbg_right'>
                                <div className='category_invoice_title'>
                                    <h4>Quotation Settings</h4>
                                    <p>Set your notification preferences for when you are in or away from the dashboard</p>
                                </div>
                                <div className='justify-content-start mb-3'>

                                    {/* <div className='d-flex align-items-center mt-3'>
                                    <div className='me-3'>
                                        <h4>Rate/Kg</h4>
                                        <p>Please enter the rate per kg.</p>
                                    </div>
                                    <div style={{ width: '200px' }}>
                                        <Form.Control type="text" placeholder="Enter Rate" value={formData.rate}
                                            onChange={(e) => setFormData(prev => ({ ...prev, rate: e.target.value }))} />
                                    </div>
                                </div> */}
                                    <div className='d-flex align-items-center mt-3'>
                                        <div className='me-3'>
                                            <h4>Shipment Type</h4>
                                            <p>Select transport type; divisor updates automatically.</p>
                                        </div>
                                        <div style={{ width: '200px' }}>
                                            <Select
                                                options={shipmentTypeOptions}
                                                placeholder="Select Type"
                                                className=""
                                                value={shipmentTypeOptions.find(option => option.value === formData.shipment_type)}
                                                onChange={handleShipmentTypeChange}
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            />
                                        </div>
                                    </div>
                                    <div className='d-flex align-items-center mt-3'>
                                        <div className='me-3'>
                                            <h4>Divisor</h4>
                                            <p>Auto-set based on shipment type (Air Cargo: 6000, Courier: 5000).</p>
                                        </div>
                                        <div style={{ width: '200px' }}>
                                            <Form.Control type="text" placeholder="Divisor" value={formData.divisor || ''} readOnly />
                                        </div>
                                    </div>
                                </div>
                                {/* <Button variant="primary" onClick={handleOnSave} disabled={isSaving}>
                                Save
                            </Button> */}
                            </div>
                        </div>
                    {/* </div>
                </div>
            </div> */}
        </>
    )
}

export default QuotationSettings
